<template>
  <v-card
    class="mt-2"
    style="border: 1px solid red;"
    flat
    v-if="!should_clip"
  >
    <v-card-title>
      Olet live-tilassa
    </v-card-title>
    <v-card-text>
      Soittimen rajoitusten vuoksi klippaaminen tai ajan mittaaminen ei ole mahdollista
      live-tilassa. Helpon tapa kiertää tämä on siirtyä muutama sekunti taaksepäin live-lähetyksestä.
      <div v-tooltip="'Paina tästä kerran tai kaksi'" class="pt-2" style="display: flex; justify-content: center;">
        <v-btn color="primary" @click="skip(-5)">- 5 s</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  methods: {
    ...mapActions('player', [
      'skip'
    ])
  },
}
</script>